import {createAction} from 'util/redux';
import {PropertyID} from 'module/Properties/enum/PropID';
import {CompoundPropertyTO} from 'generated/JavaTO';

const NAMESPACE = 'PROPERTIES/'
export const fetchPropertiesAction = createAction<PropertyID[]>(NAMESPACE + 'FETCH');

export const propertiesResponseAction = createAction<CompoundPropertyTO[]>(NAMESPACE + 'RESPONSE');
